"use client";

import type { RefObject } from "react";

import { CcAntiqueHeroPicture } from "@/components/layout/CcAntiqueHeroPicture";

type CcContactAntiqueHeroBackdropProps = {
  /** Optional ref for scroll parallax on the media layer (parallax-panel). */
  mediaRef?: RefObject<HTMLDivElement | null>;
  /** Footer-attached seam fades (parallax-panel hero column + dark-split full bleed). */
  showAttachedFooterSeam?: boolean;
  /** Stronger scrim/vignette on the antique hero (dark-split contact). */
  darkSplitScrim?: boolean;
};

/** Antique hero image + grain/scrim overlays + vignette — shared by parallax-panel and dark-split. */
export function CcContactAntiqueHeroBackdrop({
  mediaRef,
  showAttachedFooterSeam = false,
  darkSplitScrim = false,
}: CcContactAntiqueHeroBackdropProps) {
  return (
    <>
      <div
        className={`cc-contact__hero-backdrop${
          darkSplitScrim ? " cc-contact__hero-backdrop--dark-split" : ""
        }`}
        aria-hidden="true"
      >
        <div ref={mediaRef} className="cc-contact__hero-backdrop-media">
          <CcAntiqueHeroPicture fetchPriority="high" sourceOrder="webp-first" />
        </div>
        <div className="cc-contact__hero-backdrop-vignette" />
      </div>
      {showAttachedFooterSeam ? (
        <>
          <div
            className="cc-contact__parallax-bottom-fade cc-contact__parallax-bottom-fade--in-layout"
            aria-hidden="true"
          />
          <div
            className="cc-contact__parallax-bottom-slip cc-contact__parallax-bottom-slip--in-layout"
            aria-hidden="true"
          />
        </>
      ) : null}
    </>
  );
}
